"use client";

import { Genres } from "@/components/_types/genres";
import { trackClick } from "@/components/util/functions";
import Link from "next/link";
import { FaChevronDown } from "react-icons/fa";

const NavLinks = ({
	genres,
	categories,
}: {
	genres: Genres;
	categories: Genres;
}) => {
	return (
		<div className="hidden lg:flex gap-12 text-sm">
			{[
				{ name: "کات من", link: "/dashboard", onClickTrack: false },
				{ name: "اخبار", link: "/news", onClickTrack: true },
				{
					name: "بازی",
					link: "/games/categories",
					dropdown: true,
					onClickTrack: true,
					submenuItems: [
						{
							name: "ژانرها",
							items: genres?.games,
							link: "/games/genres",
							linkBase: "/games/genres",
						},
						{
							name: "دسته بندی ها",
							items: categories?.games,
							link: "/games/categories",
							linkBase: "/games/categories",
						},
					],
				},
				{
					name: "فیلم",
					link: "/movies/categories",
					dropdown: true,
					onClickTrack: true,
					submenuItems: [
						{
							name: "ژانرها",
							items: genres?.movies,
							link: "/movies/genres",
							linkBase: "/movies/genres",
						},
						{
							name: "دسته بندی ها",
							items: categories?.movies,
							link: "/movies/categories",
							linkBase: "/movies/categories",
						},
					],
				},
				{
					name: "سریال",
					link: "/series/categories",
					dropdown: true,
					onClickTrack: true,
					submenuItems: [
						{
							name: "ژانرها",
							items: genres?.series,
							link: "/series/genres",
							linkBase: "/series/genres",
						},
						{
							name: "دسته بندی ها",
							items: categories?.series,
							link: "/series/categories",
							linkBase: "/series/categories",
						},
					],
				},
				{
					name: "بازی رومیزی",
					link: "/board-games/categories",
					dropdown: true,
					onClickTrack: true,
					submenuItems: [
						{
							name: "ژانرها",
							items: genres?.boardGames,
							link: "/board-games/genres",
							linkBase: "/board-games/genres",
						},
						{
							name: "دسته بندی ها",
							items: categories?.boardGames,
							link: "/board-games/categories",
							linkBase: "/board-games/categories",
						},
					],
				},
			].map((item, index) => (
				<div key={index} className="relative group">
					<Link
						href={item.link}
						className="flex items-center justify-between gap-2 font-medium hover:text-gray-400 text-[20px]"
						onClick={() => {
							if (item.onClickTrack) {
								trackClick(item.link);
							}
						}}
					>
						{item.name} {item.dropdown && <FaChevronDown size={10} />}
					</Link>
					{item.dropdown && (
						<div className="absolute top-full left-1/2 -translate-x-1/2 py-2 w-max bg-dark-blue/80 text-white rounded-md shadow-lg z-10 opacity-0 group-hover:opacity-100 group-hover:block pointer-events-none group-hover:pointer-events-auto">
							{item.submenuItems.map((submenu, subIndex) => (
								<div key={subIndex} className="relative group/submenu">
									<Link
										href={submenu.link || "#"}
										className="flex items-center justify-between gap-5 px-4 py-2 hover:bg-gray-700"
										onClick={() => {
											if (item.onClickTrack) {
												trackClick(item.link);
											}
										}}
									>
										{submenu.name}{" "}
										{submenu.items && <FaChevronDown size={10} />}
									</Link>

									{submenu.items && (
										<div className="absolute top-0 right-full py-2 w-max bg-dark-blue/80 text-white rounded-md shadow-lg opacity-0 group-hover/submenu:opacity-100 pointer-events-none group-hover/submenu:pointer-events-auto">
											{submenu.items.map((genre, genreIndex) => (
												<Link
													key={genreIndex}
													href={`${submenu.linkBase}/${genre.id}`}
													className="block px-4 py-2 hover:bg-gray-700"
													onClick={() => {
														if (item.onClickTrack) {
															trackClick(item.link);
														}
													}}
												>
													{genre.persianName}
												</Link>
											))}
											<Link
												href={`${submenu.linkBase}`}
												className="block px-4 py-2 hover:bg-gray-700"
												onClick={() => {
													if (item.onClickTrack) {
														trackClick(item.link);
													}
												}}
											>
												همه {submenu?.name}
											</Link>
										</div>
									)}
								</div>
							))}
						</div>
					)}
				</div>
			))}
		</div>
	);
};

export default NavLinks;
